import BaseFilter from '../modules/filters/baseFilter';
import simpleLightbox from 'simplelightbox';

export default class AttachmentSection {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.cards = this.root.querySelectorAll('[data-attachments-group]');
        this.tabsEl = this.root.querySelector('[data-filter-switcher]');
        this.accordionEl = this.root.querySelector('[data-attachments-toggle]');
        this.tabs = null;

        this.cardImagePrevEl = this.root.querySelectorAll('.card-attachment__preview');
        this.blockInit = this.root.getAttribute('data-block-init');

        this.activeTabName = null;

        return true;
    }

    init() {
        this.setTabs();
        this.setAccordion();
        this.setLightbox();
    }

    setTabs() {
        if (!this.tabsEl) return;
        this.tabs = new BaseFilter(this.tabsEl, this.root);
        this.root.addEventListener('filter-switcher-change', event => {
            this.switchTabs(event);
            
            if (window.innerWidth < 992) {
                const accordion = this.root.querySelector('.filter-switcher__accordion:not(:empty)');
                if (accordion) accordion.scrollIntoView();
            }
        });
        
        if (window.innerWidth > 992) {
            if (this.blockInit !== 'true') this.tabs.toggleClick(0);
        } else {
            this.resetTabs();
        }
    }

    setAccordion() {
        if (!this.accordionEl) return;

        this.accordionEl.addEventListener('click', event => {
            const { innerWidth } = window;
            if (innerWidth > 992) return;

            this.root.classList.toggle('accordion');
        });
    }

    switchTabs(event) {
        const { detail } = event;
        const { value, el, target } = detail;

        if (this.activeTabName === value) return;

        this.activeTabName = value;
        this.resetTabs();
        this.setActiveTab(this.activeTabName);
        this.setAccordionGroupContent(detail);
    }

    resetTabs() {
        if (!this.cards) return;
        this.cards.forEach(item => item.classList.remove('active'));
    }

    resetAccordionTabs() {
        const accordionTabs = this.root.querySelectorAll(
            '.filter-switcher__accordion'
        );
        if (!accordionTabs) return;

        accordionTabs.forEach(item => {
            item.innerHTML = '';
        });
    }

    setAccordionGroupContent(data) {
        const { value, el, target } = data;
        const isAccordionMobile = el.classList.contains(
            'filter-switcher--mobileAccordion'
        );

        this.resetAccordionTabs();
        if (!isAccordionMobile) return;

        const group = this.root.querySelector(
            `[data-attachments-group="${value}"]`
        );
        if (!group) return;

        const groupHTML = group.innerHTML;
        const accordionEl = target.nextElementSibling;

        if (!accordionEl) return;
        accordionEl.innerHTML = groupHTML;
    }

    setActiveTab(value) {
        const el = this.root.querySelector(
            `[data-attachments-group="${value}"]`
        );
        if (!el) return;

        el.classList.add('active');
    }

    resetTabs() {
        const tabs = this.root.querySelectorAll('[data-attachments-group]');
        if (!tabs) return;

        tabs.forEach(item => item.classList.remove('active'));
    }

    setLightbox() {
        if (!this.cardImagePrevEl) return;

        this.cardImagePrevEl.forEach(item => {
            const anchorEl = item.querySelector('a');
            console.log(anchorEl);
            

            if (anchorEl) {
                new simpleLightbox(anchorEl, {
                    closeText: '',
                    loop: false,
                });
            }
        })
    }
}

const sections = document.querySelectorAll('[data-attachments]');
const initAttachmentSections = sections => {
    if (sections) {
        sections.forEach(section => new AttachmentSection(section));
    }
};

initAttachmentSections(sections);
